import CustomCard from '../../../../../components/CustomCard';
import { DISABLED_CARD_STYLE } from '../Model/Models';
import RequestStatusCardApp from '../Functionality/RequestStatusCardApp';
/**
 * @Author: Susana García Rodríguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 *
 * Displays a set of status cards showing the count of requests by their status.
 * It uses data from the `statusData` array and filters statuses based on `statusToShow`.
 * Each card includes:
 *  - Status icon
 *  - Translated status title
 *  - Total count of requests for that status
 *
 * @param {Object} props - Component props.
 * @param {Array} props.status - Array of objects containing status information.
 * @param {Array<number>} [props.statusToShow=[]] - Optional array of status IDs to display.
 * @returns {JSX.Element} A grid of status cards.
 */
const RequestStatusCard = ({ status = [], statusToShow = [], modified }) => {
      const { filteredStatus, t } = RequestStatusCardApp({ status, statusToShow });
       if (!filteredStatus.length) return null;
    return (
        <div className='row d-flex mt-3 mx-0 px-0'>
            {filteredStatus?.map((item) => item && item.Icon ? (
                <div key={item.id} className='col-sm-12 col-md-6 col-lg-2 col-xxl-2 mb-2'>
                    <CustomCard
                        classCard={`card-border-8px ${item.disabled ? DISABLED_CARD_STYLE.classCard : item.classCard}`}
                        classContent='px-3 py-3'
                        classes='h-100'
                    >
                        <div className='d-flex align-items-center gap-2'>
                            <div>
                                <item.Icon  className={` ${item.disabled ? DISABLED_CARD_STYLE.iconColor : item.iconColor}`} />
                            </div>

                            <div>
                                <p
                                    className={`ibl-font-w-700 ibl-h5 ${
                                        item.disabled ? DISABLED_CARD_STYLE.fontColor : item.fontColor
                                    }`}
                                >
                                    {t(item.titleTrans)}
                                </p>
                                <p
                                    className={`ibl-font-w-700 ibl-h5 ${
                                        item.disabled ? DISABLED_CARD_STYLE.fontColor : item.fontColor
                                    }`}
                                >
                                    {item.total}
                                </p>
                            </div>
                        </div>
                    </CustomCard>
                </div>
            ):null)}
        </div>
    );
};

export default RequestStatusCard;
